/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeRecordingValidationKey {
  static readonly TIME_RECORD_PROJECT = 'time-recording/validation/time-record-project';
}
